<script lang="ts" setup>
import Btn, { ButtonStyle } from '@/components/input/Btn/Btn.vue';
import { onMounted } from 'vue';
type ButtonSize = 'btn-ss' | 'btn-sm' | 'btn-md' | 'btn-lg' | '';

// ClickFuncの型を定義(Function型）
declare type ClickFunc = (args?: any) => any;

// props
const props = withDefaults(
  defineProps<{
    onClick: ClickFunc;
    buttonStyle?: ButtonStyle;
    size?: ButtonSize;
    disabled?: boolean;
    toolTipValue?: string;
    eventModifier?: string;
  }>(),
  {
    buttonStyle: 'btn-primary',
    size: 'btn-md',
    disabled: false,
    toolTipValue: '',
    eventModifier: '',
  }
);
// 変数
</script>

<template>
  <btn
    :class="props.size"
    :button-style="props.buttonStyle"
    :disabled="props.disabled"
    :tool-tip-value="props.toolTipValue"
    :event-modifier="props.eventModifier"
    :on-click="props.onClick"
  >
    <slot />
  </btn>
</template>
